/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ForgetPasswordVM } from '../models/ForgetPasswordVM';
import type { LoginResponseVMResponseVM } from '../models/LoginResponseVMResponseVM';
import type { LoginVM } from '../models/LoginVM';
import type { LoginWithCodeVM } from '../models/LoginWithCodeVM';
import type { SetPasswordVM } from '../models/SetPasswordVM';
import type { SignupVM } from '../models/SignupVM';
import type { StringResponseVM } from '../models/StringResponseVM';
import type { UserBaseWithPasswordVM } from '../models/UserBaseWithPasswordVM';
import type { UserLoginHistoryVMIEnumerableResponseVM } from '../models/UserLoginHistoryVMIEnumerableResponseVM';
import type { VerifyEmailVM } from '../models/VerifyEmailVM';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class LoginService {
    /**
     * @param requestBody
     * @returns StringResponseVM Success
     * @throws ApiError
     */
    public static postApiLoginSignup(
        requestBody?: SignupVM,
    ): CancelablePromise<StringResponseVM> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Login/signup',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns LoginResponseVMResponseVM Success
     * @throws ApiError
     */
    public static postApiLogin(
        requestBody?: LoginVM,
    ): CancelablePromise<LoginResponseVMResponseVM> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Login',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns LoginResponseVMResponseVM Success
     * @throws ApiError
     */
    public static postApiLogin2Fa(
        requestBody?: LoginWithCodeVM,
    ): CancelablePromise<LoginResponseVMResponseVM> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Login/2fa',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns LoginResponseVMResponseVM Success
     * @throws ApiError
     */
    public static putApiLoginVerifyEmail(
        requestBody?: VerifyEmailVM,
    ): CancelablePromise<LoginResponseVMResponseVM> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Login/verify-email',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns StringResponseVM Success
     * @throws ApiError
     */
    public static postApiLoginForgetPassword(
        requestBody?: ForgetPasswordVM,
    ): CancelablePromise<StringResponseVM> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Login/forget-password',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns StringResponseVM Success
     * @throws ApiError
     */
    public static postApiLoginInviteUser(
        requestBody?: ForgetPasswordVM,
    ): CancelablePromise<StringResponseVM> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Login/invite-user',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param leaseApplicationInviteCode
     * @param requestBody
     * @returns LoginResponseVMResponseVM Success
     * @throws ApiError
     */
    public static postApiLoginAcceptLeaseApplicationInvite(
        leaseApplicationInviteCode: string,
        requestBody?: UserBaseWithPasswordVM,
    ): CancelablePromise<LoginResponseVMResponseVM> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Login/{leaseApplicationInviteCode}/accept-lease-application-invite',
            path: {
                'leaseApplicationInviteCode': leaseApplicationInviteCode,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns LoginResponseVMResponseVM Success
     * @throws ApiError
     */
    public static postApiLoginSetPassword(
        requestBody?: SetPasswordVM,
    ): CancelablePromise<LoginResponseVMResponseVM> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Login/set-password',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param authorization
     * @returns any Success
     * @throws ApiError
     */
    public static putApiLoginLogout(
        authorization?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Login/logout',
            headers: {
                'Authorization': authorization,
            },
        });
    }
    /**
     * @returns any Success
     * @throws ApiError
     */
    public static putApiLoginIsalive(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Login/isalive',
        });
    }
    /**
     * @param userId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns UserLoginHistoryVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiLoginUserLoginHistory(
        userId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<UserLoginHistoryVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Login/user-login-history/{userId}',
            path: {
                'userId': userId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
}
